import { endOfDay, isWithinInterval, startOfDay, subDays } from "date-fns";
import { getValidDate } from "ui/lib/helpers";

type memberHealth = "HEALTHY" | "ACTIVE" | "SLIPPING" | "PULSE" | "DEAD";

const dateWithin_Days =
  (days: number) =>
  (value: Date | string): boolean => {
    if (!value) return false;

    return isWithinInterval(getValidDate(value), {
      end: endOfDay(new Date()),
      start: startOfDay(subDays(new Date(), days)),
    });
  };

const dateWithin7Days = dateWithin_Days(7);
const dateWithin14Days = dateWithin_Days(14);
const dateWithin30Days = dateWithin_Days(30);

export const getMemberHealth = ({
  lastWOCompletedAt,
  lastActivityAt,
}: {
  lastWOCompletedAt: Date | string;
  lastActivityAt: Date | string;
}): memberHealth => {
  if (dateWithin7Days(lastWOCompletedAt)) {
    return "HEALTHY";
  }
  if (dateWithin14Days(lastWOCompletedAt)) {
    return "ACTIVE";
  }
  if (dateWithin30Days(lastWOCompletedAt)) {
    return "SLIPPING";
  }
  if (dateWithin14Days(lastActivityAt)) {
    return "PULSE";
  }
  return "DEAD";
};
